<template lang="pug">
  v-card(:flat="flat")
    v-card-text
      .d-flex
        div
          h2.mt-2 {{ title }}
          p.mt-2 {{ subject.title || subject.name }}
      .mx-n9.my-4
      template(v-if="!loading")
        div(
          v-for="(task, idx) in tasks"
          :key="task.id"
        )
          v-row(
            no-gutters
            align="center"
          ).task.nowrap
            div
              p.pre-wrap: strong {{ task.title }}
              span
                | Выполнений - {{ task.total_journals }}

            v-spacer
            .text-center
              v-btn(
                fab
                text
                target="_blank"
                :to="toAnalytic(task)"
              )
                v-icon(large) mdi-poll
              .caption Аналитика

          v-divider.my-5(v-if="idx !== tasks.length - 1")
      v-alert(
        v-if="!tasks.length && !loading"
        color="primary"
        text
      )
        v-icon(color="primary").mr-2 mdi-information
        span Заданий не предусмотрено
      v-skeleton-loader(
        v-if="loading"
        type="list-item@3"
      )
</template>

<script>
import Course from '@/models/list/Course';
import Unit from '@/models/list/Unit';

import { SUBJECT_TYPES } from '@/modules/Education/Teach/constants';

export default {
  props: {
    subject: { type: Object, required: true },
    flat: { type: Boolean, default: false },
  },
  data: () => ({
    tasks: [],
    loading: false,
  }),
  computed: {
    title() {
      const TITLES = {
        [SUBJECT_TYPES.course]: 'Курсовые работы',
        [SUBJECT_TYPES.unit]: 'Тематические задания',
        [SUBJECT_TYPES.lesson]: 'Задания урока',
      };
      return TITLES[this.subjectType];
    },
    subjectType() {
      if (this.subject instanceof Course) {
        return SUBJECT_TYPES.course;
      }
      if (this.subject instanceof Unit) {
        return SUBJECT_TYPES.unit;
      }
      return SUBJECT_TYPES.lesson;
    },
    progress() {
      if (!this.tasks.length) return 0;
      const successed = this.tasks.filter((t) => t.status === this.$conf.TASK_STATUSES.success);
      return (100 / this.tasks.length) * successed.length;
    },
  },
  watch: {
    subject: {
      handler() {
        this.fetchTasks();
      },
      immediate: true,
    },
  },
  methods: {
    toAnalytic(task) {
      return {
        name: 'TaskCheckAnalytic',
        params: { id: task.id },
      };
    },
    async fetchTasks() {
      this.loading = true;
      const API = {
        [SUBJECT_TYPES.course]: () => this.$api.tasks.taskStatistics(
          {
            'search[course]': this.subject.id,
          },
        ),
        [SUBJECT_TYPES.unit]: () => this.$api.tasks.taskStatistics(
          {
            'search[course_unit]': this.subject.id,
          },
        ),
        [SUBJECT_TYPES.lesson]: () => this.$api.tasks.taskStatistics(
          {
            'search[lesson]': this.subject.id,
          },
        ),
      };
      const response = await API[this.subjectType]();
      this.tasks = response.data.data;
      this.loading = false;
    },
  },
};
</script>
